import axios from "../api";
export const getGallerySets = async () => {
    const res = await axios.get("/gallery/sets");
    return res.data;
};
//# sourceMappingURL=getGallerySets.js.map